(function ($) {
  Drupal.behaviors.basicGridFormatter_V2 = {
    attach: function (context) {
      var $content = $('.js-grid-formatter', context);

      if ($content.length) {
        $('.js-basic-grid-formatter img', context).on('load', function () {
          $content.find('.js-grid-formatter-item').matchHeight();
        });
      }
    }
  };
})(jQuery);
